import { useCart } from '../../context/CartContext';
import { useLang } from '../../i18n';
import { useProduct, eur } from '../../lib/shopify';
import { SmartImg } from '../Image';
import { FadeUp, MaskedLines } from '../motion';

export default function FinalCta() {
  const { product } = useProduct('01-chrome');
  const { addLine, busy } = useCart();
  const { t } = useLang();
  const variant =
    product?.variants?.find((v) => v.available) || product?.variants?.[0] || null;

  return (
    <section
      data-testid="final-cta-section"
      className="border-t border-black/10 bg-white px-4 py-24 text-center sm:py-32"
    >
      <FadeUp>
        <SmartImg
          src="/assets/title-chrome.png"
          alt="01 / CHROME"
          label="01 / CHROME"
          className="mx-auto w-56 sm:w-80"
        />
      </FadeUp>
      <FadeUp delay={0.1}>
        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.4em] text-neutral-500">
          {t('final.drop')}
        </p>
      </FadeUp>
      <FadeUp delay={0.15}>
        <p
          data-testid="final-price"
          className="mt-4 font-mono text-2xl uppercase tracking-[0.3em]"
        >
          {eur(variant?.price ?? product?.price ?? 24.9)}
        </p>
      </FadeUp>
      <FadeUp delay={0.2}>
        <button
          type="button"
          data-testid="final-preorder-button"
          disabled={!variant || busy}
          onClick={() => addLine(product, variant, 1)}
          className="mt-8 rounded-full bg-ink px-10 py-4 font-mono text-[11px] uppercase tracking-[0.35em] text-bone transition-colors duration-300 hover:bg-neutral-700 disabled:cursor-not-allowed disabled:opacity-40"
        >
          {t('product.add')}
        </button>
      </FadeUp>
      <FadeUp delay={0.25}>
        <p className="mt-4 font-mono text-[9px] uppercase tracking-[0.25em] text-neutral-500">
          {t('preorder.shipping')}
        </p>
      </FadeUp>

      <div className="mt-20">
        <MaskedLines
          className="font-mono text-[10px] uppercase tracking-[0.45em] text-neutral-800 sm:text-xs"
          lines={["Things you don't need."]}
        />
        <MaskedLines
          className="mt-2 font-mono text-[8px] uppercase tracking-[0.4em] text-neutral-500 sm:text-[10px]"
          lines={["But you'll want them anyway."]}
        />
      </div>
    </section>
  );
}
